module.exports = __webpack_public_path__ + "static/media/perk-solopreneur-4.ce5e7be0.png";